import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Book, Clapperboard, Gamepad2, Info } from 'lucide-react'
import Logo from '@/assets/ali-ulvi.png'
import Modal from '@/components/ui/Modal'
import { useModal } from '@/context/ModalContext'
import UserService from '@/services/api/userService'

const Home = () => {
  const navigate = useNavigate()
  const modal = useModal()

  const [user, setUser] = useState(null)

  const getData = async () => {
    const user = await UserService.get()
    setUser(user)
    console.log(user)
  }

  useEffect(() => {
    getData()
  }, [])

  // Sayfa uygulamanın içinde bir WebView'da açılıyor ve kapatma yetkisi
  // uygulamada: RN tarafı 'close' mesajını dinleyip modalı kapatıyor
  // (mobil depo, OnlineBasvuruModal -> onMessage, data === 'close').
  // Android'de sistem geri tuşu da kapatıyordu, iOS'ta öyle bir tuş yok —
  // bu buton çalışmayınca sayfa iOS'ta çıkışsız kalıyordu.
  // Normal tarayıcıda ReactNativeWebView tanımsızdır; buton sessizce durur.
  const closeApp = () => {
    window.ReactNativeWebView?.postMessage('close')
  }

  // Renkler
  const colors = ['#000000', '#AC5E2A', '#5A9779', '#8A1B12']

  const menuItems = [
    {
      id: 'kutuphane',
      title: 'Prof.Dr. Mustafa Sabri KÜÇÜKAŞÇI Kütüphanesi',
      icon: <Book size={24} />,
      path: '/kutuphane',
      onclick: (item) => {
        if (item.disabled || !user?.is_open_kutuphane) {
          modal.show('Çok Yakında')
          return
        }
        navigate(item.path)
      },
      disabled: false,
    },
    {
      id: 'sinema',
      title: 'Sinema Salonu',
      icon: <Clapperboard size={24} />,
      path: '/sinema',
      onclick: (item) => {
        if (item.disabled || !user?.is_open_sinema_salonu) {
          modal.show('Çok Yakında')
          return
        }

        navigate(item.path)
      },
    },
    {
      id: 'playStation',
      title: 'PlayStation',
      icon: <Gamepad2 size={24} />,
      path: '/playStation',
      onclick: (item) => {
        if (item.disabled) {
          modal.show('Çok Yakında')
          return
        }

        navigate(item.path)
      },
      disabled: true,
    },
    {
      id: 'hakkinda',
      title: 'Hakkında',
      icon: <Info size={24} />,
      path: '/hakkinda',
      onclick: (item) => {
        if (item.disabled) {
          modal.show('Çok Yakında')
          return
        }

        navigate(item.path)
      },
      disabled: false,
    },
  ]

  return (
    <div className='p-3'>
      {/* Logo ve Başlık */}
      <div className='text-[#AC5E2A] p-6 flex justify-between items-center'>
        {/* Sol: Logo + Başlık */}
        <div className='flex items-center gap-3'>
          <div className='w-16 h-16 rounded-full flex items-center justify-center shadow-lg'>
            <img src={Logo} alt='' />
          </div>
          <div>
            <h1 className='text-xl font-bold text-start'>Ali Ulvi Kurucu</h1>
            <p className='text-[#AC5E2A] text-sm text-start'>Gençlik Merkezi</p>
          </div>
        </div>

        {/* Sağ: Kapat Butonu */}
        <button onClick={closeApp} className='w-9 h-9 me-3 rounded-full bg-[#AC5E2A]/10 hover:bg-[#AC5E2A]/20 flex items-center justify-center transition-colors'>
          <svg xmlns='http://www.w3.org/2000/svg' className='w-5 h-5 text-[#AC5E2A]' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2}>
            <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
          </svg>
        </button>
      </div>

      {/* Menü Butonları */}
      <div className='grid grid-cols-2 gap-4 px-2 mt-4'>
        {menuItems.map((item, index) => {
          const bgColor = colors[index % colors.length] // 🔥 otomatik döngü

          return (
            <button
              key={item.id}
              onClick={() => {
                item.onclick(item)
              }}
              style={{ backgroundColor: bgColor }}
              className={`aspect-square flex flex-col items-center justify-center text-white rounded-2xl shadow-lg active:scale-95 transition-transform ${item.disabled ? 'cursor-not-allowed' : ''}`}
            >
              <div className='bg-white/30 p-3 rounded-full mb-2'>{item.icon}</div>
              <span className='text-xs font-semibold text-center leading-tight px-1'>{item.title}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default Home
